import { createContext } from "react";

const InformesContext = createContext();

export default InformesContext;
